export default "__VITE_PUBLIC_ASSET__9891b32e__"